import React from 'react'
import RebuildImage from "@/assets/changelog- rebuild.png"
import Button from '@/shared/components/UI/Button'
import ArrowUpRight from '@/shared/icons/ArrowUpRight'

const AnnouncementModal = ({ onClose, onExplorePlatform, onReadChangelog }) => {
  const handleExplorePlatform = () => {
    if (onExplorePlatform) {
      onExplorePlatform();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleReadChangelog = () => {
    window.open('https://www.dante-ai.com/changelogs', '_blank');
    if (onReadChangelog) {
      onReadChangelog();
    }
  };

  return (
    <div className='fixed inset-0 z-[9999] flex justify-center items-center bg-v3-bg-light w-full animate-fadeIn overflow-y-auto'>
      <div className='w-full min-h-full flex justify-center items-center p-v3-md'>
        <div className='flex flex-col items-start gap-v3-md sm:gap-v3-xl flex-shrink-0 w-full max-w-[600px] py-v3-huge'>
          <img src={RebuildImage} alt="Rebuild Image" className='w-full h-auto object-contain animate-fadeInUpDelayed1 min-h-[215px] md:min-h-[365px]'/>
          <div className='flex flex-col items-start gap-v3-sm sm:gap-v3-md self-stretch font-inter-variable animate-fadeInUpDelayed2'>
            <h3 className='text-v3-black-max text-v3-h5 sm:text-v3-h3 font-bolder'>Dante AI 2.0: Chapter 1</h3>
            <p className='text-v3-black-max text-v3-h11 sm:text-v3-h9 font-normal'>We rebuilt the entire platform from scratch. New design system, new analytics capabilities, new deployment management, and performance improvements across the board.</p>
            <p className='text-v3-black-max text-v3-h11 sm:text-v3-h9 font-normal'>This is just the foundation. Chapter 2 is already in development.</p>
          </div>
          <div className='flex flex-col sm:flex-row items-center gap-v3-sm self-stretch animate-fadeInUpDelayed3'>
            <Button
              className='w-full sm:w-auto justify-center'
              label='Explore the Platform'
              variant='primary'
              size='lg'
              onClick={handleExplorePlatform}
            />
            <Button
              iconAfter={ArrowUpRight}
              label='Read Full Changelog'
              variant='secondary'
              className='!bg-transparent !border-none w-full sm:w-auto justify-center'
              size='lg'
              onClick={handleReadChangelog}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AnnouncementModal